import { Dispatch, SetStateAction } from "react";
import { ISelectValue } from "../constants/app.dto";
import * as LocalData from "./localData";

export const generateRandomID = () => {
    // creating random id for inputs
    let milliSeconds = ((new Date()).getTime() / 2);
    let randomNumber = Math.floor(Math.random() * 999999)
    
    return milliSeconds + "" + randomNumber;
}

export const generateEncryptEmail = (email: string) => {
    if(email.indexOf("@") !== -1){
        let [user, domain] = email.split("@");
        let userEncrypted = user.split("").map((s,i) => i > 0 ? "*" : s).join("");  

        return `${userEncrypted}@${domain}`;
    }
    return "******@*****";
}

export const hasUpperCaseLetter = (str: string) => {
    for (var i=0; i<str.length; i++){
      if (str.charAt(i) === str.charAt(i).toUpperCase() && str.charAt(i).match(/[a-z]/i)){
        return true;
      }
    }
    return false;
}

export const hasNumber = (str: string) => (
    /\d/.test(str)
)

export const convertToBase64 = (file: any) => {
    return new Promise(resolve => {
        let baseURL: any = "";
        // Make new FileReader
        let reader = new FileReader();
    
        // Convert the file to base64 text
        reader.readAsDataURL(file);
    
        // on reader load somthing...
        reader.onload = () => {
            // Make a fileInfo Object
            baseURL = reader.result;
            resolve(baseURL);
        };
    });
};

export const saveUserAuthData = (authData: any) => {
    if(!authData) return;

    const {signInUserSession} = authData;
    
    LocalData.saveLocalData(LocalData._tokenName, signInUserSession.accessToken.jwtToken);
    LocalData.saveLocalData(LocalData._refreshTokenName, signInUserSession.refreshToken.token);
}

export const deleteUserAuthData = () => {
    LocalData.deleteLocalData(LocalData._tokenName);
    LocalData.deleteLocalData(LocalData._refreshTokenName);
}

export const isObjectEmpty = (obj: any) => {
    let arrValues = Object.keys(obj);
    let isEmpty = false;

    arrValues.forEach((value) => {
        if((Array.isArray(obj[value]) && !obj[value].length) || (value === null)){
            isEmpty = true;
        }
    })

    return isEmpty;
}

export const getLabelFromSelect = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    let options = target.children;
    let ind = 0;
    
    for(ind = 0; ind < options.length; ind++){
        if(options[ind].getAttribute("value") === target.value)
            return options[ind].innerHTML;
    }
    return "";
}

export const formatValuesForSelect = (setDispatch: Dispatch<SetStateAction<any>>, data: ISelectValue[]) => {
    const formattedData = Array.isArray(data) ? data.map((i: ISelectValue) => ({
        label: i.name , value: i.id
    })) : [];
    setDispatch(formattedData);
}

export const getHourDiff = (date: string) => {
    const dateCurrent = new Date();
    const dateOpportunity = new Date(date);

    let diff =(dateCurrent.getTime() - dateOpportunity.getTime()) / 1000;
    diff = diff / (60 * 60);
    diff = Math.abs(Math.round(diff));

    let diffText = diff > 48 ? `${Math.floor(diff/24)} dias`: `${diff} hora${diff === 1 ? '' : 's'}`;
    
    return {
        createdAtText: diffText , 
        isNew: diff < 72,
    };
}

export const formatCurrency = (wage: number): string => {
    const formatter = new Intl.NumberFormat('es-PE', {
        style: 'currency',
        currency: 'PEN',
        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
    return formatter.format(wage);
}

export const mapCompany = (companyId: string) => {
    const companies = {
        "TWA": {
            avatar: "https://customer-profile-production.s3.amazonaws.com/images-perfil/69cd0e74-1e0d-46b3-93c9-bff6aa6aeadf1677508107151.jpeg",
            name: "Tawa",
        },
        "VLC": {
            avatar: "https://customer-profile-staging.s3.amazonaws.com/images-perfil/0d42cbd6-a257-4f9f-9738-b18ca2c96da4.jpeg",
            name: "Volcan",
        },
        "KPK": {
            avatar: "https://media.istockphoto.com/id/1192683174/vector/building-icon-logo-isolated-on-white-background-skyscraper-office-center-high-rise-buildings.jpg?s=170667a&w=0&k=20&c=aD8O8qiyiO6qBfa0024MhILbjOO2VznrLjEji7Hm0zo=",
            name: "Kapak",
        }
    }

    return (companies as any)[companyId] || companies.TWA;
}